import { useContext } from 'react'
import AuthContext from 'app/contexts/AmplifyAuthContext'

const useAuth = () => useContext(AuthContext)

export default useAuth
